module.exports = require('./helpers/bundle-url').getBundleURL('4xJtr') + "logo.c51670a8.svg";